var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAboutMainBoxBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "1520px",
    height: "792.455px",
    viewBox: "0 0 1520 792.455",
    enableBackground: "new 0 0 1520 792.455",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75BB",
    stroke: "#1B75BB",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    cx: 310.309,
    cy: 310.03,
    r: 1.572
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75BB",
    stroke: "#1B75BB",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    cx: 425.374,
    cy: 327.511,
    r: 1.572
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75BB",
    stroke: "#1B75BB",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    cx: 209.524,
    cy: 405.817,
    r: 1.572
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75BB",
    stroke: "#1B75BB",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    cx: 210.379,
    cy: 277.908,
    r: 1.572
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B75BB",
    stroke: "#1B75BB",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    d: "M155.827,242.988c0,0.869-0.703,1.57-1.571,1.57 c-0.87,0-1.573-0.701-1.573-1.57c0-0.871,0.704-1.572,1.573-1.572C155.125,241.416,155.827,242.117,155.827,242.988z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B75BB",
    stroke: "#1B75BB",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    d: "M144.281,228.553 c0,0.869-0.706,1.571-1.575,1.571c-0.867,0-1.572-0.702-1.572-1.571c0-0.871,0.706-1.571,1.572-1.571 C143.576,226.981,144.281,227.682,144.281,228.553z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B75BB",
    stroke: "#1B75BB",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    d: "M252.446,227.506c0,0.869-0.702,1.57-1.572,1.57 c-0.865,0-1.571-0.701-1.571-1.57c0-0.872,0.707-1.572,1.571-1.572C251.744,225.934,252.446,226.634,252.446,227.506z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75BB",
    stroke: "#1B75BB",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    cx: 231.742,
    cy: 265.771,
    r: 1.571
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B75BB",
    stroke: "#1B75BB",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    d: "M275.843,241.48 c0,0.869-0.702,1.576-1.571,1.576c-0.87,0-1.572-0.707-1.572-1.576c0-0.866,0.702-1.571,1.572-1.571 C275.141,239.909,275.843,240.614,275.843,241.48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B75BB",
    stroke: "#1B75BB",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    d: "M254.361,439.927 c0,0.864-0.703,1.572-1.572,1.572c-0.866,0-1.572-0.708-1.572-1.572c0-0.87,0.706-1.573,1.572-1.573 C253.658,438.354,254.361,439.057,254.361,439.927z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B75BB",
    stroke: "#1B75BB",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    d: "M154.969,506.624 c0,0.869-0.707,1.572-1.572,1.572c-0.87,0-1.576-0.703-1.576-1.572c0-0.865,0.706-1.571,1.576-1.571 C154.263,505.053,154.969,505.759,154.969,506.624z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75BB",
    stroke: "#1B75BB",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    cx: 295.893,
    cy: 593.936,
    r: 1.572
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B75BB",
    stroke: "#1B75BB",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    d: "M210.201,636.01 c0,0.867-0.706,1.573-1.572,1.573c-0.87,0-1.576-0.706-1.576-1.573c0-0.869,0.706-1.571,1.576-1.571 C209.495,634.438,210.201,635.141,210.201,636.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B75BB",
    stroke: "#1B75BB",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    d: "M184.188,429.865 c0,0.869-0.705,1.576-1.572,1.576c-0.87,0-1.571-0.707-1.571-1.576c0-0.866,0.702-1.571,1.571-1.571 C183.482,428.294,184.188,428.999,184.188,429.865z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75BB",
    stroke: "#1B75BB",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    cx: 380.119,
    cy: 290.062,
    r: 1.572
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75BB",
    stroke: "#1B75BB",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    cx: 425.374,
    cy: 282.027,
    r: 1.572
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75BB",
    stroke: "#1B75BB",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    cx: 405.044,
    cy: 277.195,
    r: 1.572
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75BB",
    stroke: "#1B75BB",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    cx: 312.605,
    cy: 265.496,
    r: 1.572
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75BB",
    stroke: "#1B75BB",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    cx: 366.734,
    cy: 440.493,
    r: 1.573
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B75BB",
    stroke: "#1B75BB",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    d: "M393.855,319.224c0,0.864-0.703,1.57-1.572,1.57 c-0.87,0-1.572-0.706-1.572-1.57c0-0.87,0.702-1.573,1.572-1.573C393.152,317.65,393.855,318.354,393.855,319.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B75BB",
    stroke: "#1B75BB",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    d: "M348.018,285.895 c0,0.87-0.709,1.572-1.575,1.572c-0.866,0-1.572-0.702-1.572-1.572s0.706-1.57,1.572-1.57 C347.308,284.324,348.018,285.024,348.018,285.895z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B75BB",
    stroke: "#1B75BB",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    d: "M337.062,241.48 c0,0.869-0.703,1.576-1.572,1.576c-0.869,0-1.571-0.707-1.571-1.576c0-0.866,0.702-1.571,1.571-1.571 C336.359,239.909,337.062,240.614,337.062,241.48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B75BB",
    stroke: "#1B75BB",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    d: "M334.682,344.994 c0,0.87-0.706,1.573-1.575,1.573c-0.866,0-1.572-0.703-1.572-1.573c0-0.868,0.706-1.57,1.572-1.57 C333.976,343.424,334.682,344.126,334.682,344.994z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75BB",
    stroke: "#1B75BB",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    cx: 393.979,
    cy: 228.993,
    r: 1.572
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinejoin: "bevel",
    strokeMiterlimit: 10,
    points: "122.314,590.742 122.314,241.908  210.554,291.388 295.722,241.086 295.497,595.688 208.905,636.922  "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1B75BB",
    strokeMiterlimit: 10,
    x1: 209.27,
    y1: 636.336,
    x2: 210.554,
    y2: 291.388
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinejoin: "bevel",
    strokeMiterlimit: 10,
    points: "142.946,227.728 142.309,241.941  209.563,278.931 274.272,242.151 274.061,227.514 295.722,241.086 210.554,291.388 122.314,241.908  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinejoin: "bevel",
    strokeMiterlimit: 10,
    points: "143.372,213.937 210.623,250.853  274.061,214.573 274.061,242.151 209.563,278.931 142.309,241.941  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinejoin: "bevel",
    strokeMiterlimit: 10,
    points: "154.984,211.554  157.643,199.884 209.976,228.568 262.639,199.717 262.941,213.937  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinejoin: "bevel",
    strokeMiterlimit: 10,
    points: "262.639,199.717  250.169,190.704 250.947,197.693 208.607,221.39 168.552,195.866 171.078,191.169 157.643,199.884  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1B75BB",
    strokeMiterlimit: 10,
    points: "208.632,220.888 210.139,107.388 250.169,190.704  "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1B75BB",
    strokeMiterlimit: 10,
    x1: 169.218,
    y1: 195.209,
    x2: 210.001,
    y2: 106.639
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#1B75BB",
    strokeMiterlimit: 10,
    points: "122.314,241.908 209.127,407.026 200.373,430.529  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinejoin: "bevel",
    strokeMiterlimit: 10,
    points: "142.309,241.941  210.623,250.853 209.563,278.931 143.03,213.379 149.612,208.922 209.165,243.56 267.904,211.252 274.061,214.573  209.563,278.931  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1B75BB",
    strokeMiterlimit: 10,
    points: "210.474,291.388 182.455,430.529 122.314,241.908  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#1B75BB",
    strokeMiterlimit: 10,
    points: "122.282,591.139 210.477,459.628 200.373,430.529  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1B75BB",
    strokeMiterlimit: 10,
    points: "209.127,636.575 182.542,430.529 122.282,591.139  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinejoin: "bevel",
    strokeMiterlimit: 10,
    d: "M209.127,636.575 c0.059-0.239,86.595-395.489,86.595-395.489l-85.167,50.302l84.942,304.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1B75BB",
    strokeMiterlimit: 10,
    points: "151.155,334.07 122.755,401.084 153.331,507.434  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1B75BB",
    strokeMiterlimit: 10,
    points: "228.846,146.835 210.205,174.271 250.947,197.693  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1B75BB",
    strokeMiterlimit: 10,
    points: "192.775,145.021 209.142,173.816 168.552,195.866  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#1B75BB",
    strokeMiterlimit: 10,
    points: "274.061,242.151 250.874,228.177 231.742,266.442  210.623,250.853 163.356,253.465 142.557,230.173 181.826,234.997 209.563,278.931 228.748,240.489  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinejoin: "bevel",
    strokeMiterlimit: 10,
    points: "154.984,211.554  209.976,228.568 209.165,243.56 262.639,199.717  "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1B75BB",
    strokeMiterlimit: 10,
    d: "M337.041,546.855"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#1B75BB",
    strokeMiterlimit: 10,
    points: "333.022,345.419 333.022,546.855 356.693,552.938  388.779,552.938 402.832,546.855 397.229,346.219  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#1B75BB",
    strokeMiterlimit: 10,
    points: "310.197,310.29 333.022,345.419 397.229,345.99  425.577,327.705 425.577,313.99 393.629,333.665 334.751,328.685 311.07,296.358  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1B75BB",
    strokeMiterlimit: 10,
    points: "312.373,280.027 312.373,265.457 344.855,301.799  392.21,306.474 425.235,282.646 425.687,299.386  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinejoin: "bevel",
    strokeMiterlimit: 10,
    points: "312.536,265.116 334.151,253.09  335.057,269.377 345.911,287.17 379.995,291.543 405.179,277.972 404.746,249.113 425.133,282.393  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinejoin: "bevel",
    strokeMiterlimit: 10,
    points: "335.206,241.632 359.203,227.208  393.793,229.484 404.746,249.113  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1B75BB",
    strokeMiterlimit: 10,
    d: "M374.264,242.054c0,3.042-3.497,5.502-7.809,5.502 c-4.308,0-7.805-2.46-7.805-5.502c0-3.035,3.497-5.499,7.805-5.499C370.767,236.555,374.264,239.019,374.264,242.054z"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1B75BB",
    strokeMiterlimit: 10,
    x1: 366.455,
    y1: 169.649,
    x2: 366.455,
    y2: 241.107
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1B75BB",
    strokeMiterlimit: 10,
    x1: 210.474,
    y1: 38.546,
    x2: 210.474,
    y2: 110.005
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1B75BB",
    strokeMiterlimit: 10,
    x1: 333.022,
    y1: 345.419,
    x2: 311.343,
    y2: 297.883
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1B75BB",
    strokeMiterlimit: 10,
    points: "425.577,327.705 425.577,538.406 403.091,546.91  333.022,345.419 393.561,333.629 397.133,346.14 425.577,314.639 425.577,298.097 392.545,320.086 339.78,315.868  312.373,280.027 311.07,296.358  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1B75BB",
    strokeMiterlimit: 10,
    d: "M312.536,280.009"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1B75BB",
    strokeMiterlimit: 10,
    points: "312.605,266.167 339.939,315.159 392.367,306.223  392.367,319.926 425.133,282.393  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinejoin: "bevel",
    strokeMiterlimit: 10,
    points: "335.173,269.286 345.304,259.752  345.896,287.159 379.26,265.713 379.856,290.732 404.746,249.113 379.089,265.457 345.312,259.728 335.206,241.632  334.151,253.242  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1B75BB",
    strokeMiterlimit: 10,
    points: "310.197,310.29 310.197,538.909 332.79,546.91  397.133,346.14  "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1B75BB",
    strokeMiterlimit: 10,
    d: "M122.333,465.195L16.246,526.663 c-16.403,9.505-16.301,33.227,0.182,42.589l197.754,112.343c7.507,4.265,16.698,4.272,24.212,0.024l228.742-129.363 c7.62-4.309,16.96-4.232,24.51,0.195l100.615,93.13h345.458l315.194-211.435c15.705-9.199,16.283-31.694,1.081-41.693 l-64.722-42.563c-15.155-9.962-14.643-32.351,0.945-41.616l115.301-68.511c15.355-9.124,16.137-31.067,1.473-41.262 l-101.029-70.222c-7.802-5.42-18.033-5.857-26.268-1.112L1063.2,194.276c-8.358,4.818-18.766,4.29-26.596-1.35l-90.065-64.834 c-7.933-5.713-18.499-6.172-26.898-1.176L721.625,244.765c-7.674,4.567-17.233,4.607-24.944,0.094L491.93,125.147 c-7.732-4.52-17.32-4.471-25.005,0.136L285.767,233.79"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutMainBoxBg);
export default __webpack_public_path__ + "static/media/aboutMainBoxBg.981b2805f7aad4ce9a96a1df11715da3.svg";
export { ForwardRef as ReactComponent };